var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('SideNav'),_vm._v(" "),_c('div',{staticClass:"page-container"},[_c('TransitionPage',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }